import styled from 'styled-components'

export const FormFieldSwitchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
`
